/* @ngInject */
function PostDetailsController ($q, $cookies, $scope, $rootScope, $attrs, $sce, $timeout, NewAssetService, PostsService, AttachmentService, Utils, CONSTANTS, AssetService, ToastService, SliderService, SegmentService) {
  $scope.$element = $attrs.$$element

  $scope.detailsOpen = false
  $scope.animationDone = true
  $scope.contentLoaded = false
  $scope.post = {}

  function _loadDetails () {
    const deferred = $q.defer()

    PostsService.getPostById($scope.postId).then(function (oPost) {
      $scope.content = $sce.trustAsHtml(oPost.content)
      $scope.post = oPost
      $scope.attachments = oPost.attachments.map(function (oFile) {
        return angular.extend(oFile, {
          src: {
            original: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, [oFile.id]),
            default: AssetService.getAssetThumbnailByType(oFile.type),
            thumbnail: Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [oFile.id])
          },
          contentType: oFile.contentType,
          type: oFile.type
        })
      }).filter(attachment => attachment.type !== 'EMBEDDED')
      $scope.speed = 250 + ($scope.attachments.length > 0 ? 250 : 0)
      deferred.resolve()
    }).catch(deferred.reject)
    return deferred.promise
  }

  $scope.downloadAttachment = function (attachment) {
    PostsService.downloadAttachment(attachment.id)
      .then(PostsService.registerAttachmentLog.bind(this, attachment.id, $scope._postId, 'DOWNLOAD'))
      .then(() => {
        SegmentService.track('downloaded-attachment', { attachment_id: attachment.id, post_id: $scope._postId })
      })
  }

  $scope.downloadWithProgress = function (sId, progressCallback, callback) {
    AttachmentService.downloadWithProgress(sId, progressCallback, callback, CONSTANTS.URL_CUSTOMER_ASSETS_DOWNLOAD_ID, {
      query: {
        jwt: $cookies.get('jwt')
      },
      externalUrl: true
    })
      .then(PostsService.registerAttachmentLog.bind(this, sId, $scope._postId, 'DOWNLOAD'))
      .then(() => {
        SegmentService.track('downloaded-attachment', { attachment_id: sId, post_id: $scope._postId })
      })
  }

  $scope.disattach = function (assetId) {
    const fileIndex = $scope.attachments.findIndex(file => file.id === assetId)
    $scope.attachments.slice(fileIndex, 1)
  }

  $scope.attActions = {
    download: $scope.downloadAttachment,
    downloadWithProgress: $scope.downloadWithProgress,
    delete: $scope.disattach.bind($scope),
    logPostView,
    seeAttachmentLogs
  }

  function seeAttachmentLogs (attachmentId) {
    if (!$rootScope.isDesktop) {
      SliderService.setState('post-slider', 'close')
      SliderService.setState('attachment-logs-slider', 'open', {
        attachmentId,
        postId: $scope.postId
      })
    }
  }

  function logPostView (attachmentId) {
    PostsService.registerAttachmentLog(attachmentId, $scope._postId, 'VIEW')
    SegmentService.track('previewed-attachment', { attachment_id: attachmentId, post_id: $scope._postId })
  }

  function _stopPropagation () {
    $scope.$element.find('.attachment--preview').click(event => event.stopPropagation())
    $scope.$element.find('.file-thumbnail-overlay').click(event => event.stopPropagation())
    $scope.stopPropagation = true
  }

  $scope.handleClick = function (state) {
    if (!$scope.contentLoaded) {
      $scope.loading = true
      _loadDetails()
        .then(function () {
          $scope.contentLoaded = true
          $timeout(function () {
            $scope.loading = false
            $scope.handleClick(true)
          }, 200)
        })
        .catch(function () {
          $scope.loading = false
          ToastService.defaultErrorToast()
        })
    } else {
      if ($scope.animationDone && !$scope.attachmentIsHover) {
        if (state) {
          $scope.unread = false
          $scope.animationDone = false
          $scope.detailsOpen = true
          $($scope.$element).slideDown($scope.speed, function () {
            if (!$scope.stopPropagation) { _stopPropagation() }
            $scope.animationDone = true
          })
        } else {
          $($scope.$element).slideUp($scope.speed, function () {
            $scope.animationDone = true
            $scope.detailsOpen = false
          })
        }
      }
    }
  }

  $('.content#' + $scope.postId).on('click', function () { $scope.handleClick(!$scope.detailsOpen) })
}

export { PostDetailsController }
